import React from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Link } from "@mui/material";

export interface AdditionalAvailabilityItem {
  id: number;
  schedule: string;
  days: number[];
  startTime: string;
  endTime: string;
}

interface CurrentAdditionalAvailabilityProps {
  availabilityData: AdditionalAvailabilityItem[];
  onRemove: (id: number) => void;
}

const CurrentAdditionalAvailability: React.FC<CurrentAdditionalAvailabilityProps> = ({ 
  availabilityData, 
  onRemove 
}) => {
  if (availabilityData.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: { xs: 3, md: 4 } }}>
      <TableContainer
        sx={{
          border: "1px solid #E0E0E0",
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#E8F0FC" }}>
              <TableCell
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "14px", sm: "16px" },
                  color: "#000000",
                  padding: { xs: "12px 16px", sm: "16px 24px" },
                  paddingRight: { xs: "24px", sm: "32px" },
                  borderBottom: "1px solid #E0E0E0",
                  borderRight: "1px solid #E0E0E0",
                  width: "50%",
                }}
              >
                Current Additional Availability
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 600,
                  fontSize: { xs: "14px", sm: "16px" },
                  color: "#000000",
                  padding: { xs: "12px 16px", sm: "16px 24px" },
                  paddingLeft: { xs: "24px", sm: "32px" },
                  borderBottom: "1px solid #E0E0E0",
                  width: "50%",
                  textAlign: "center",
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {availabilityData.map((item) => (
              <TableRow
                key={item.id}
                sx={{
                  "&:hover": {
                    backgroundColor: "#FAFAFA",
                  },
                }}
              >
                <TableCell
                  sx={{
                    fontSize: { xs: "13px", sm: "14px" },
                    color: "#000000",
                    padding: { xs: "12px 16px", sm: "16px 24px" },
                    paddingRight: { xs: "24px", sm: "32px" },
                    borderBottom: "1px solid #E0E0E0",
                    borderRight: "1px solid #E0E0E0",
                    width: "50%",
                  }}
                >
                  {item.schedule}
                </TableCell>
                <TableCell
                  sx={{
                    padding: { xs: "12px 16px", sm: "16px 24px" },
                    paddingLeft: { xs: "24px", sm: "32px" },
                    borderBottom: "1px solid #E0E0E0",
                    width: "50%",
                    textAlign: "center",
                  }}
                >
                  <Link
                    onClick={() => onRemove(item.id)}
                    sx={{
                      color: "#10389A",
                      fontSize: { xs: "13px", sm: "14px" },
                      fontWeight: 500,
                      cursor: "pointer",
                      textDecoration: "underline",
                      "&:hover": {
                        color: "#0c2a75",
                      },
                    }}
                  >
                    Remove
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CurrentAdditionalAvailability;

